import {Workbox} from 'workbox-window';

let wb: Workbox | null = null;
export const getWb = () => wb;

export function registerServiceWorker(onWaiting: () => void, onControlling?: () => void) {
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
        wb = new Workbox('/service-worker.js');

        wb.addEventListener('waiting', () => {
            onWaiting();
        });
        wb.addEventListener('controlling', () => {
            onControlling?.();
        });

        wb.register().catch(console.error);

        // раз в 10 минут проверяем обновления
        setInterval(() => wb?.update().catch(() => {}), 1.5 * 60 * 1000);
    }
}
